import { useQuery } from 'react-query';
import { IFilters } from '../components/TableFilters/useFilters';
import { MatchesService } from '../utils/MatchesService';
import { transformAllMatchData } from '../utils/transformAllMatches';
import { AxiosError } from 'axios';
import { useToast } from './useToast';
import { transformQueryError } from '../utils/transformQueryError';
import { HistoryStatsQueryParams } from '../models/HistoricalStats';

export const useHistoryStats = (params: HistoryStatsQueryParams) => {
  const { addAlert } = useToast();

  const { isLoading, isError, data, isSuccess, error } = useQuery(
    ['/api/stats/history', params.statName, params.awayTeamId, params.homeTeamId],
    () => {
      return MatchesService.getStatHistory(params);
    },
    {
      // select: transformAllMatchData,
      onError: (err: AxiosError) => {
        const status = err.response?.status;
        if (status === 401 || status === 403) {
          addAlert({
            key: `onError-${new Date().getMilliseconds()}-api/stats/history`,
            message: 'You need to login to see matches information',
            type: 'error',
          });
        }
      },
    },
  );

  const transformedError = transformQueryError(error);

  // if (!data) {
  //   return {
  //     isLoading,
  //     isError,
  //     error: transformedError,
  //     isSuccess,
  //     matches: {
  //       count: {
  //         all: 0,
  //         home: 0,
  //         away: 0,
  //         mutual: 0,
  //       },
  //       data: [],
  //     },
  //   };
  // }

  return {
    isLoading,
    isError,
    isSuccess,
    matches: data,
    error: transformedError,
  };
};
